"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  const fallbackLinks = [{
    id: "home",
    label: "Home",
    href: "/HomePage"
  }, {
    id: "products",
    label: "Products",
    href: "#products"
  }, {
    id: "services",
    label: "Services",
    href: "#services"
  }, {
    id: "our-story",
    label: "Our Story",
    href: "#our-story"
  }];
  const itemsToRender = menuItems && menuItems.length > 0 ? menuItems : fallbackLinks;
  if (loading) {
    return <div data-section-id="27873" className="flex flex-col gap-4 p-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-3/4 bg-muted animate-pulse rounded-md" data-index={i} />)}
      </div>;
  }
  return <nav className="flex flex-col gap-2 p-4">
      {itemsToRender.map((item, i) => <div key={item.id} data-index={i} className="w-full">
            <Link to={item.href || "#"} className="block w-full text-lg font-medium font-sans text-foreground py-3 border-b border-border/50 hover:text-primary transition-colors tracking-wide" onClick={onClose}>
            {item.label}
            </Link>
        </div>)}
      <div className="mt-6 flex flex-col gap-4">
        <Button className="w-full shadow-lg shadow-primary/20 bg-primary text-primary-foreground rounded-full font-sans" asChild>
            <Link to="#schedule">Schedule Now</Link>
        </Button>
      </div>
    </nav>;
}
export default function SiteNavigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  const desktopLinks = [{
    label: "Products",
    href: "#products"
  }, {
    label: "Services",
    href: "#services"
  }, {
    label: "Our Story",
    href: "#our-story"
  }, {
    label: "Schedule",
    href: "#schedule"
  }];
  return;
}